import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../features/blogs/blogsSlice";
import SingleBlog from "./SingleBlog";
import Loading from "../utils/Loading";

export default function BlogContainer() {
  const dispatch = useDispatch();
  const { isLoading, isError, blogs, error } = useSelector(
    (state) => state.blogs
  );
  const { sort, isSaved } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchBlogs({ sort, isSaved }));
  }, [dispatch, isSaved, sort]);

  //Decide what to render
  let content;

  if (isLoading) {
    content = <Loading />;
  }

  if (!isLoading && isError) {
    content = <div className="text-lg text-gray-500">{error}</div>;
  }

  if (!isLoading && !isError && blogs?.length === 0) {
    content = <p className="text-lg text-gray-500">No Blogs Found</p>;
  }

  if (!isLoading && !isError && blogs?.length > 0) {
    content = blogs.map((blog) => (
      <SingleBlog
        key={blog.id}
        blog={blog}
      />
    ));
  }

  return (
    <main
      className="post-container"
      id="lws-postContainer"
    >
      {content}
    </main>
  );
}
